/**
 * Utility functions for working with TypeScript types, these should be functions that are note
 * specific to any given type or schema, but meant to be used for common occurences.
 *
 * I.e. "objectKeys" which is a better (for typescript) version of "Object.keys"
 */
export var objectKeys = function (obj) {
    return Object.keys(obj);
};
export var objectValues = function (obj) {
    return Object.values(obj);
};
